import { Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { Toaster } from 'react-hot-toast';
import { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css'
import Dashboard from './pages/dashboard/Dashboard';
import CategoryManager from './pages/dashboard/CategoryManager';
import AuthorManager from './pages/dashboard/AuthorManager';
import BookManager from './pages/dashboard/BookManager';
import BookForm from './pages/dashboard/BookForm';
import RevenueManager from './pages/dashboard/RevenueManager';
import BannerManager from './pages/dashboard/BannerManagerPage';
import Home from './pages/home/Home';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutUs from './pages/home/About';
import ExploreBooks from './pages/home/ExploreBooks';
import BookDonationForm from './pages/home/BookDonationForm';
import BookSuggestionForm from './pages/home/BookSuggestionForm';
import Signup from './pages/home/Signup';
import Login from './pages/home/Login';
import ForgotPassword from './pages/home/ForgotPassword';
import OtpVerification from './pages/home/OtpVerification';
import ChangePassword from './pages/home/ChangePassword';
import ExploreAuthors from './pages/home/ExploreAuthors';
import PackageManager from './pages/dashboard/PackageManager'
import MembershipPlans from './pages/home/MembershipPlans';
import Wishlist from './pages/home/Wishlist';
import Cart from './pages/home/Cart'
import AuthPopup from './components/home/authComponents/AuthPopup';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCart } from './features/cartSlice';
import { fetchWishlist } from './features/wishlistSlice';
import UserProfile from './pages/home/UserProfilePage';
import AdminLogin from './components/home/authComponents/AdminLogin';
import SubscriptionDetails from './pages/home/SubscriptionDetailsPage';
import MyOrders from './pages/home/MyOrdersPage';
import AdminOrderRequests from './pages/dashboard/AdminOrderRequestsPage';
import AdminReturnRequests from './pages/dashboard/AdminReturnRequests';
import BookOrderHistoryPage from './pages/dashboard/BookOrderHistoryPage';
import DatabaseBackupPage from './pages/dashboard/DatabaseBackupPage';
import JustLaunchedBooks from './pages/home/JustLaunchedBooks';
import TrendingBooks from './pages/home/TrendingBooks';
import BestReadsBooks from './pages/home/BestReadsBooks';
import BookDetailsPage from './pages/home/BookDetailsPage';
import BooksByAuthorPage from './pages/home/BooksByAuthorPage';
import Loader from './components/home/Loader';
import OrderConfirmationPage from './pages/home/OrderConfirmationPage';
import PrivacyPolicyPage from './pages/home/PrivacyPolicyPage';
import CancellationPolicyPage from './pages/home/CancellationPolicyPage';
import TermsAndConditionsPage from './pages/home/TermsAndConditionsPage';
import ShippingPolicyPage from './pages/home/ShippingPolicyPage';
import ReturnPolicyPage from './pages/home/ReturnPolicyPage';
import PickupDeliveryPolicyPage from './pages/home/PickupDeliveryPolicyPage';
import MultiOrderPage from './pages/home/MultiOrderPage';
import BookSuggestionManagerPage from './pages/dashboard/BookSuggestionManagerPage';
import BookDonationManagerPage from './pages/dashboard/BookDonationManagerPage';
import FAQ from './pages/home/FAQ';
import UserManager from './pages/dashboard/UserManager';
import SubscribedUsersPage from './pages/dashboard/SubscribedUsersPage';
import ContactUsPage from './pages/home/ContactUsPage';
import Search from './pages/home/Search';
import UpcomingPlanPage from './pages/home/UpcomingPlanPage';
import ComingSoonPage from './pages/home/ComingSoonPage';
import BookWithMePage from './pages/home/BookWithMePage';
import UserDetailsPage from './pages/dashboard/UserDetailsPage';
import OfferManager from './pages/dashboard/OfferManager';
import CouponManager from './pages/dashboard/CouponManager';
import AdminNotificationManager from './pages/dashboard/AdminNotificationManager';
import NotificationsCenter from './pages/dashboard/NotificationsCenter';
import BookInventory from './pages/dashboard/BookInventory';
import ExpiringSubscribersPage from './pages/dashboard/ExpiringSubscribersPage';
import BooksWithUsersPage from './pages/dashboard/BooksWithUsersPage';
import TopRatedBooksPage from './pages/home/TopRatedBooksPage';
import SubscriptionSuccess from './pages/home/SubscriptionSuccess';
import CityManager from './pages/dashboard/CityManager';
import ExpiredSubscribers from './pages/dashboard/ExpiredSubscribers';
import EcoCreditsPage from './pages/home/EcoCreditsPage';
import ScrollToTop from './utils/ScrollToTop';
import { jwtDecode } from 'jwt-decode';
import { logout } from './features/authSlice';
import AllReviews from './pages/home/AllReviews'
import InvestorsPage from './pages/home/InvestorsPage';
import InvestorEnquiryManager from './pages/dashboard/InvestorEnquiryManager';
import ActivityLogPage from './pages/dashboard/ActivityLogPage';
import AdminUsersPage from './pages/dashboard/AdminUsersPage';
import DeliveryManagementPage from './pages/dashboard/DeliveryManagementPage';
import TestimonialManagerPage from './pages/dashboard/TestimonialManagerPage';
import DeliveryLoginPage from './pages/delivery/DeliveryLoginPage';
import DeliveryDashboardPage from './pages/delivery/DeliveryDashboardPage';
import DeliveryOrdersPage from './pages/delivery/DeliveryOrdersPage';
import DeliveryReturnsPage from './pages/delivery/DeliveryReturnsPage';
import DeliveryLayout from './components/delivery/DeliveryLayout';


function App() {

  const [showAuth, setShowAuth] = useState(false);
  const requireAuth = () => setShowAuth(true);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [isLoading, setIsLoading] = useState(true);

  

  useEffect(() => {
    const token = localStorage.getItem('authToken');

    if (!token) return;

    try {
      const { exp } = jwtDecode(token);
      const currentTime = Date.now();

      if (exp * 1000 < currentTime) {
        dispatch(logout());
      } else {
        const timeout = setTimeout(() => {
          dispatch(logout());
        }, exp * 1000 - currentTime);

        return () => clearTimeout(timeout); // Clean up on unmount
      }
    } catch (err) {
      dispatch(logout());
    }
  }, [dispatch]);

  useEffect(() => {
    // Simulate a loading delay (e.g., API call)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    if (isAuthenticated && user?.id) {
      dispatch(fetchCart(user.id));
      dispatch(fetchWishlist(user.id));
    }
  }, [isAuthenticated, user, dispatch]);

  if (isLoading) {
    return <Loader />;
  }


  return (
  <div className='container-fluid font-nunito'>
     <ScrollToTop />
    <Routes>
      {/*Dashboard Routes */}
    <Route path='/adminDashboard' element={<Dashboard />} />
    <Route path='/categoryManager' element={<CategoryManager />} />
    <Route path='/authorManager' element={<AuthorManager />} />
    <Route path='/bookManager' element={<BookManager />} />
    <Route path='/bookForm' element={<BookForm />} />
    <Route path='/bookForm/:bookId' element={<BookForm />} />
    <Route path='/revenue-manager' element={<RevenueManager />} />
    <Route path='/bannerManager' element={<BannerManager />} />
    <Route path='/packageManager' element={<PackageManager />} />
    <Route path='/admin' element={<AdminLogin />} />
    <Route path='/adminOrderRequests' element={<AdminOrderRequests />} />
    <Route path='/adminReturnRequests' element={<AdminReturnRequests />} />
    <Route path='/book-order-history' element={<BookOrderHistoryPage />} />
    <Route path='/database-backup' element={<DatabaseBackupPage />} />
    <Route path='/book-suggestions' element={<BookSuggestionManagerPage />} />
    <Route path='/book-donations' element={<BookDonationManagerPage />} />
    <Route path='/user-manager' element={<UserManager />} />
    <Route path='/subscribed-users' element={<SubscribedUsersPage />} />
    <Route path="/admin/users/:userId" element={<UserDetailsPage />} />
    <Route path='/offer-manager' element={<OfferManager />} />
    <Route path='/coupon-manager' element={<CouponManager />} />
    <Route path='/notification-manager' element={<AdminNotificationManager />} />
    <Route path='/notifications-center' element={<NotificationsCenter />} />
    <Route path='/inventory-manager' element={<BookInventory />} />
    <Route path='/city-manager' element={<CityManager />} />
    <Route path='/expiring-subscribers' element={<ExpiringSubscribersPage />} />
    <Route path='/bookswithusers' element={<BooksWithUsersPage />} />
    <Route path='/expired-subscribers' element={<ExpiredSubscribers />} />
    <Route path='/investor-enquiries' element={<InvestorEnquiryManager />} />
    <Route path='/activity-log' element={<ActivityLogPage />} />
    <Route path='/admin-users' element={<AdminUsersPage />} />
    <Route path='/delivery-manage' element={<DeliveryManagementPage />} />
    <Route path='/testimonial-manager' element={<TestimonialManagerPage />} />


      {/*Home Routes */}
      <Route path='/' element={<Home />} />
      <Route path='/aboutUs' element={<AboutUs />} />
      <Route path='/explore-books' element={<ExploreBooks  onRequireAuth={requireAuth}/>} />
      <Route path='/donate-books' element={<BookDonationForm />} />
      <Route path='/suggest-book' element={<BookSuggestionForm />} />
      <Route path='/signup' element={<Signup />} />
      <Route path='/login' element={<Login />} />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/verification' element={<OtpVerification />} />
      <Route path='/change-password' element={<ChangePassword />} />
      <Route path='/explore-authors' element={<ExploreAuthors />} />
      <Route path='/membershipPlans' element={<MembershipPlans />} />
      <Route path='/Wishlist' element={<Wishlist onRequireAuth={requireAuth}/>} />
      <Route path='/Cart' element={<Cart onRequireAuth={requireAuth}/>} />
      <Route path='/profile' element={<UserProfile onRequireAuth={requireAuth}/>} />
      <Route path='/subscription-details' element={<SubscriptionDetails onRequireAuth={requireAuth}/>} />
      <Route path='/myOrders' element={<MyOrders onRequireAuth={requireAuth}/>} />
      <Route path='/justlaunched-books' element={<JustLaunchedBooks />} />
      <Route path='/trending-books' element={<TrendingBooks />} />
      <Route path='/bestreads-books' element={<BestReadsBooks />} />
      <Route path='/book/:id' element={<BookDetailsPage />} />
      <Route path="/author/:authorId" element={<BooksByAuthorPage />} />
      <Route path="/order-confirmation/:bookId" element={<OrderConfirmationPage />} />
      <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
      <Route path='/faq' element={<FAQ />} />
      <Route path='/cancellation-policy' element={<CancellationPolicyPage />} />
      <Route path='/terms-and-conditions' element={<TermsAndConditionsPage />} />
      <Route path='/shipping-policy' element={<ShippingPolicyPage />} />
      <Route path='/return-policy' element={<ReturnPolicyPage />} />
      <Route path='/pickup-delivery-policy' element={<PickupDeliveryPolicyPage />} />
      <Route path='/multi-book-order' element={<MultiOrderPage />} />
      <Route path='/contact-us' element={<ContactUsPage />} />
      <Route path='/search' element={<Search />} />
      <Route path='/upcoming-plans/:userId' element={<UpcomingPlanPage />} />
      <Route path='/buy-books' element={<ComingSoonPage />} />
      <Route path='/books-with-me' element={<BookWithMePage />} />
      <Route path='/top-rated-books' element={<TopRatedBooksPage />} />
      <Route path='/subscriptionsuccess' element={<SubscriptionSuccess />} />
      <Route path='/eco-credits' element={<EcoCreditsPage />} />
      <Route path="/book/:id/reviews" element={<AllReviews />} />
      <Route path='/investors' element={<InvestorsPage />} />

      {/* Delivery Partner Routes */}
      <Route path='/delivery/login' element={<DeliveryLoginPage />} />
      <Route path='/delivery' element={<DeliveryLayout />}>
        <Route path='dashboard' element={<DeliveryDashboardPage />} />
        <Route path='orders' element={<DeliveryOrdersPage />} />
        <Route path='returns' element={<DeliveryReturnsPage />} />
      </Route>

      {/* Authenticated Routes */}

    </Routes>

          <AuthPopup
            isOpen={showAuth}
            onClose={() => setShowAuth(false)}
          />
    <ToastContainer />
    <Toaster />
  </div>

  );
}

export default App;
